import React, { Component } from 'react';

class ExamTitle extends Component {
    render() {
        return (
            <div className="exam-info d-flex align-items-center center"><b>보건의료인CBT 튜토리얼</b><b>1교시</b></div>
        );
    }
}

export default ExamTitle;